import React from 'react';
import Card from '../Card';

const BarreRecherche = ({ Objet, docFiltreObjet }) => (
    <div className="input-group ml-1 mr-1">
        <div className="input-group-prepend">
            <span className="input-group-text">
                <i className="fas fa-search" />
            </span>
        </div>
        <input
            type="search"
            className="form-control"
            placeholder="Rechercher un document..."
            aria-label="Rechercher un document..."
            value={Objet}
            onChange={event => docFiltreObjet(event.target.value)}
        />
        <div className="input-group-append">
            <button className="input-group-text btn" onClick={() => docFiltreObjet('')}>
                <span className="fas fa-times" />
            </button>
        </div>
    </div>
);

const CreerGroupeFiltres = ({
    Titre, Couleur, CouleurActif, Liste, Actif, AjouterFiltre,
}) => {
    const Groupe = Liste.map((item, i) => (
        
        <button
            key={i}
            type="button"
            className={`btn  ${item === Actif ? CouleurActif + ' border-none' : Couleur} ecarter ${Actif.length>0 && item !== Actif ? 'masquer' : ''}`}
            onClick={(event) => {
                event.preventDefault();
                if (item !== Actif) {
                    AjouterFiltre(item);
                }
            }}
        >
            <i className={`${item === Actif ? 'fa fa-folder-open' : 'far fa-folder'}`}></i> {item}
            {/* <i className={`fas fa-slash ${item === Actif ? '' : 'masquer'}`}></i> */}
            <span className={`${item === Actif ? '' : 'masquer'}`}>&nbsp;&nbsp;/</span>
        </button>
    ));

    return (
        <div className="flex-wrap mb-3" role="group" aria-label={Titre}>
            <button
                type="button"
                className={`btn ${CouleurActif} ecarter ${Actif.length<1 || Titre==='Action' ? 'masquer' : ''}`}
                onClick={(event) => {
                    event.preventDefault();
                    AjouterFiltre('');
                }}
            >
                <i class="fas fa-arrow-left"></i> Retour
            </button>
            
            {Groupe}
        </div>
    );
};

const CardFiltresFolders = ({ docs, filtres, actions }) => {
    const mPrest = docs.map(item => item.Prest);
    const fPrest = mPrest.filter((value, index, array) => array.indexOf(value) === index);
    const sPrest = fPrest.sort();

    const mAct = docs
        .filter(item => item.Act && (!filtres.Prest || item.Prest === filtres.Prest))
        .map(item => item.Act);
    const fAct = mAct.filter((value, index, array) => array.indexOf(value) === index);
    const sAct = fAct.sort();

    const AjoutFiltrePrest = (filtre) => {
        actions.docFiltrePrest(filtre);
        actions.docFiltreAct('');
    };

    return (
        <div className="col-12">
            <Card>
                <div className="row mb-3">
                    <BarreRecherche Objet={filtres.Objet} docFiltreObjet={actions.docFiltreObjet} />
                </div>
                <div className="row d-flex ">
                    {sPrest.length > 0 && (
                        <CreerGroupeFiltres
                            Titre="Prestation"
                            Couleur="btn-outline-primary"
                            CouleurActif="btn-outline-dark"
                            Liste={sPrest}
                            Actif={filtres.Prest}
                            AjouterFiltre={filtres.Act.length>0 ? actions.docFiltreAct : AjoutFiltrePrest}
                        />
                    )}
                {/* </div>
                <div className="row d-flex "> */}
                    {sAct.length > 0 &&
                        filtres.Prest && (
                        <CreerGroupeFiltres
                            Titre="Action"
                            Couleur="btn-outline-success"
                            CouleurActif="btn-outline-dark"
                            Liste={sAct}
                            Actif={filtres.Act}
                            AjouterFiltre={actions.docFiltreAct}
                        />
                    )}
                </div>
            </Card>
        </div>
    );
};

export default CardFiltresFolders;



// WEBPACK FOOTER //
// ./src/components/MesDocs/CardFiltresFolders.js